import React from "react";
import "./404.css";

const Error404 = () => {
  return (
    <div className="error-page">
      <div className="error-card">
        <h1 className="error-title">404</h1>
        <p className="error-subtitle">Oops... Página no encontrada</p>
        <a href="/" className="back-home">Volver al inicio</a>
      </div>
    </div>
  );
};

export default Error404;